;!function(){try{var e="undefined"!=typeof globalThis?globalThis:"undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:offsoo-landing":true});}catch(e){}}();import { LinkPending } from '@/components/site/layout/navigation-progress'
import { clsx } from 'clsx/lite'
import NextLink from 'next/link'
import React, { forwardRef } from 'react'

const isExternalHref = (href: string) =>
  href.startsWith('http://') ||
  href.startsWith('https://') ||
  href.startsWith('//') ||
  href.startsWith('mailto:') ||
  href.startsWith('tel:')

type LinkProps = React.ComponentPropsWithoutRef<typeof NextLink> & {
  unstyled?: boolean
}

export const Link = forwardRef(function Link(
  { className, target, rel, unstyled = false, href, children, ...props }: LinkProps,
  ref: React.ForwardedRef<HTMLAnchorElement>,
) {
  const hrefAsString = typeof href === 'string' ? href : null
  const isExternal = hrefAsString ? isExternalHref(hrefAsString) : false
  const resolvedTarget = target ?? (isExternal ? '_blank' : undefined)
  const resolvedRel = rel ?? (isExternal ? 'noreferrer' : undefined)

  return (
    <NextLink
      ref={ref}
      href={href}
      target={resolvedTarget}
      rel={resolvedRel}
      className={clsx(
        !unstyled && 'inline-flex items-center gap-2 text-sm/7 font-medium text-mist-950 dark:text-white',
        className,
      )}
      {...props}
    >
      {children}
      <LinkPending />
    </NextLink>
  )
})
